export var RANGE_PRICE_DISPLAY_TYPE = 'range';
export var FIRST_PRICE_DISPLAY_TYPE = 'first';
export var ALL_PRICE_DISPLAY_TYPE = 'all';
export var PRICE_DISPLAY_TYPES = [RANGE_PRICE_DISPLAY_TYPE, FIRST_PRICE_DISPLAY_TYPE, ALL_PRICE_DISPLAY_TYPE];
export var ZERO_PRICE_LABEL = '$0.00';
export var DEFAULT_LABEL_DELIMITER = ' | ';
export var DEFAULT_RANGE_DELIMITER = ' - ';
export var DEFAULT_STARTING_AT_APPENDIX = '+';